module.exports = __webpack_public_path__ + "img/signing_blue.2ed50c0e.svg";